import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ViewContainerRef,
  ElementRef
} from '@angular/core';

// Servicios
import { DragulaService } from 'ng2-dragula';
// Components
import { NgxSmartModalService } from 'ngx-smart-modal';
import { SxBaseContainerDesigner } from '../../base/base-container-designer-component';
import { IDesignerFactoryService } from '../../../../services/designer-factory-interface';

@Component({
  selector: 'sx-simple-container-designer',
  templateUrl: './simple-container.designer.component.html'
})
export class SxSimpleContainerDesigner extends SxBaseContainerDesigner
  implements OnInit, OnDestroy {
  @ViewChild('simplePanelContainer', { read: ViewContainerRef })
  private simplePanelContainer: ViewContainerRef;
  backColor = '';
  constructor(
    dragulaService: DragulaService,
    designerFactoryService: IDesignerFactoryService,
    container: ElementRef,
    public ngxSmartModalService: NgxSmartModalService
  ) {
    super(
      dragulaService,
      designerFactoryService,
      'SxSimpleContainer',
      container
    );

    this.isSelectable = false;
  }
  ngOnInit(): void {
    this.placeHolderContainer = this.simplePanelContainer;
    super.ngOnInit();
  }

  getElementModal(instance: any) {
    this.ngxSmartModalService.setModalData(instance, 'attributesModal');
    this.ngxSmartModalService.getModal('attributesModal').open();
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/containers/simple-container.designer.component.ts